import { AgreementCode } from 'Constants/agreementCodes.constants';
import { ProductName } from 'Constants/products.constants';
import {
  SSX_GRP_OPTION,
  SSX_HOUSE_CONTENT_OPTIONS,
} from './buyHouseContentButton.types';

export const getBuyHouseContentLink = (
  productName: ProductName,
  agreementCode: AgreementCode,
): string => {
  const innbo = mapHouseContentProduct(productName);
  const partner = mapToGrpPartnerValue(agreementCode);
  return `kjop-forsikring/sjekk-pris/${innbo}/din-innboforsikring${partner ? `?grp=${partner}` : ''}`;
};

const mapToGrpPartnerValue = (
  agreementCode: AgreementCode,
): SSX_GRP_OPTION | undefined => {
  switch (agreementCode) {
    case AgreementCode.AKA_ARKITEKTENES_FAGFORBUND:
      return SSX_GRP_OPTION.AFAG;
    case AgreementCode.AKA_DEN_NORSKE_LEGEFORENING:
      return SSX_GRP_OPTION.LEGEFORENINGEN;
    case AgreementCode.AKA_DEN_NORSKE_TANNLEGEFORENING:
      return SSX_GRP_OPTION.TANNLEGEFORENINGEN;
    case AgreementCode.AKA_DEN_NORSKE_VETERINAERFORENING:
      return SSX_GRP_OPTION.VETERINARENE;
    case AgreementCode.AKA_ECONA:
      return SSX_GRP_OPTION.ECONA;
    case AgreementCode.AKA_NATURVITERNE:
      return SSX_GRP_OPTION.NATURVITERNE;
    case AgreementCode.AKA_NORSK_LEKTORLAG:
      return SSX_GRP_OPTION.LEKTORLAGET;
    case AgreementCode.AKA_NORSK_PSYKOLOGIFORENING:
      return SSX_GRP_OPTION.PSYKOLOGFORENINGEN;
    case AgreementCode.AKA_SAMFUNNSVITERNE:
      return SSX_GRP_OPTION.SAMFUNNSVITERNE;
    case AgreementCode.AKA_SAMFUNNSOKONOMENE:
      return SSX_GRP_OPTION.SAMFUNNSOKONOMENE;
    case AgreementCode.HUSEIERNE:
    case AgreementCode.HUSEIERNE_PREPAY:
    case AgreementCode.HUSEIERNE_CORPORATE:
      return SSX_GRP_OPTION.HUSEIERNE;
    case AgreementCode.DANSKE_BANK:
      return SSX_GRP_OPTION.DANSKE_BANK;
    case AgreementCode.COOP:
    case AgreementCode.COOP_PREPAY:
      return SSX_GRP_OPTION.COOP;
    default:
      return undefined;
  }
};

const mapHouseContentProduct = (
  productName: ProductName,
): SSX_HOUSE_CONTENT_OPTIONS => {
  switch (productName) {
    case ProductName.AKA_HOUSE_CONTENTS:
      return SSX_HOUSE_CONTENT_OPTIONS.AKA;
    case ProductName.HUSEIERNE_HOUSE_CONTENTS:
      return SSX_HOUSE_CONTENT_OPTIONS.HUSEIERNE;
    default:
      return SSX_HOUSE_CONTENT_OPTIONS.STANDARD;
  }
};
